const pagination = {
    input: document.querySelectorAll('.jsPagination') as NodeListOf<HTMLInputElement>,


    init() {
        this.getPage();
    },

    getPage() {
        this.input.forEach(item => {
            const url = item.dataset.url as string
            const page = url.split('&')[1]  as string
            item.addEventListener('keyup', (e) => {
                const value = item.value as string
                const num = page.split('=')[1] as string
                const get = page.replace(num, value)
                const newUrl = url.replace(page, get)
                if (e.key === 'Enter'){                   
                    window.location.href = `${window.location.origin}${newUrl}`
                }

            })
        })
    },


}

export default pagination;